/**
 * Component for displaying a list of rules
 */

import RuleItem from './RuleItem';

function RulesList({ rules, validationStatus, onDelete, selectedRuleIds, onRuleSelect, onSuggest }) {
    if (!rules || rules.length === 0) {
        return null;
    }

    return (
        <div className="rules-list">
            {rules.map(rule => (
                <RuleItem
                    key={rule.id}
                    rule={rule}
                    validation={validationStatus && validationStatus.results ? validationStatus.results[rule.id] : null}
                    onDelete={onDelete}
                    isCombined={rule.type === 'COMBINED'}
                    isSelected={selectedRuleIds && selectedRuleIds.includes(rule.id)}
                    onSelect={onRuleSelect}
                    onSuggest={onSuggest}
                />
            ))}
        </div>
    );
}

export default RulesList;
